var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"text"},[_c('img',{attrs:{"src":require("../assets/pic/pic_default_Illustration.png")}}),_c('span',[_vm._v("服务出了点小状况！")])]),_c('div',{staticClass:"beian"},[_c('span',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("Copyright © 2021 福州数智云控信息科技有限公司. All rights reserved 版权所有 | 闽ICP备2021008164号")])])])])
}]

export { render, staticRenderFns }